module.exports = function _of(x) { return [x]; };



//////////////////
// WEBPACK FOOTER
// ./~/ramdasauce/~/ramda/src/internal/_of.js
// module id = 742
// module chunks = 0